exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[data-v-25643481] {\n  background-color: transparent;\n  border: transparent;\n  outline: none;\n  box-shadow: none;\n  padding: 0 5px 0 0;\n  margin: -7px 0;\n}", ""]);

// exports
